import Vue from 'vue'
import API from '../utils/api'
import env from '../../../config/prod.env.js'

const state = {
  roles: [],
  role: null,
  sortRole: [],
  currentPage: null
}

const mutations = {  
  SET_ROLES (state, payload) {
    state.roles = payload
  },
  SET_ROLE (state, payload) {
    state.role = payload
  },
  SET_SORT_ROLE (state, payload) {
    state.sortRole = payload
  },
  SET_CURRENT_PAGE (state, payload) {
    state.currentPage = payload
  },
  API_FAILURE (state, payload) {
    throw {error: true, payload: payload.body}
  } 
}

const actions = {
  roleList: (context, data) => {
    let query = '?'        
    if (data.pagination) {
      query += `page=${data.pagination.page}&records=${data.pagination.perPage}`      
    } else {          
      query = ''
    }
    if (data.sort) {
      query += `&sortBy=${data.sort.sortBy}&sortDesc=${data.sort.sortDesc}`      
    }
    if (data.search) {
      query += `&search=${data.search}`      
    }

    return Vue.http.post(`${env.API}/api/role/list`, data)    
      .then((response) => {        
        context.commit('SET_ROLES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  roleByIds: (context, data) => {
    let query = '?'
    if (Array.isArray(data.ids)) {
      for (let element of data.ids) {                 
        query += `&ids[]=${element}`
      }
    }
    if (Array.isArray(data.role)) {
      for (let r of data.role) {
        query += `&role[]=${r}`
      }
    }
    return Vue.http.get(`${env.API}/api/role/by-ids${query}`)    
      .then((response) => {        
        context.commit('SET_ROLES', response.body.message)
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  getRoleById: (context, id) => {
    console.info(id)
    return Vue.http.get(`${env.API}/api/role/by-id/${id}`)    
      .then((response) => {
        context.commit('SET_ROLE', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateRole: (context, data) => {
    return Vue.http.put(`${env.API}/api/role/${data.id}`, data)    
      .then((response) => {                
        return response.body
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  createRole: (context, data) => {
    return Vue.http.post(`${env.API}/api/role`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  deleteRole: (context, data) => {
    return Vue.http.delete(`${env.API}/api/role/${data.id}`, data)
    .then((response) => {
      return response.body.message
    })
    .catch((error) => {
      return context.commit('API_FAILURE', error)
    })
  },
  updateSortRole: (context, data) => {
    return context.commit('SET_SORT_ROLE', data)
  },
  roleBySegTraProRole: (context, data) => {
    return Vue.http.post(`${env.API}/api/role/by-seg-trav-prod-role`, data)    
      .then((response) => {
        context.commit('SET_ROLES', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  byTriplets: (context, data) => {
    return Vue.http.post(`${env.API}/api/role/by-triplets`, data)    
      .then((response) => {
        context.commit('SET_ROLES', response.body.message)            
        return response.body.message
      })
      .catch((error) => {
        return context.commit('API_FAILURE', error)
      })
  },
  updateCurrentPage: (context, page) => {
    return context.commit('SET_CURRENT_PAGE', page)
  }
}

const getters = {
  getRoles: (state) => state.roles,
  getRole: (state) => state.role,
  getSortRole: (state) => state.sortRole,
  getCurrentPage: (state) => state.currentPage
}

export const role = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/role.js